import requestProvider from "./axiosHandler";

const getAllSupplier = () => {

    return requestProvider
        .get('/supplier/get-all')
};

const createSupplier = (list) => {

    return requestProvider
        .post('/supplier', {
            name: list.name,
            code: list.code,
            description: list.description,
            phone: list.phone,
            email: list.email,
            address: list.address
        })
};

const updateSupplier = (list) => {

    return requestProvider
        .put('/supplier', {
            name: list.name,
            code: list.code,
            description: list.description,
            phone: list.phone,
            email: list.email,
            address: list.address,
            id: list.id
        })

};

const deleteSupplier = (id) => {

    return requestProvider
        .delete(`/supplier/${id}`)
};

const getSupplierById = (id) => {

    return requestProvider
        .get(`/supplier/${id}`)
};

const getSuppliersWithPage = (page = 0, pageSize = 10) => {
    return requestProvider
        .get(`/supplier?field=createdDate&order=desc&page=${page}&per_page=${pageSize}`)
}; 

export {getAllSupplier, getSupplierById, deleteSupplier, updateSupplier, createSupplier, getSuppliersWithPage}